<template>
    <!--
        The tabs of the screen being read, above the screen (phase 2 of the menu,
        v1.542.0).

        Eleven of the fourteen entries „Nabava in zaloga“ used to hold are three JOBS
        rather than eleven screens, and a buyer moves between the six screens of one of
        them all morning. The menu now names the job once and the screens are tabs of
        it — so the six are one press apart from each other instead of a fold away, and
        the menu is short enough to read down.

        Nothing here decides anything: the row is drawn from `activeTabs`, which is the
        tab group of the SCREEN, not of the entry that was pressed. So it is right after
        a reload, after a bookmark from last March and after Milo has sent somebody to
        „Napoved potreb“ by name.

        Buttons and not `UTabs`. `UTabs` switches PANELS it renders itself — its items
        carry a value and no `to`, and the panel is its content — while these tabs are
        six routes with six lazily-loaded screens and six addresses somebody may
        bookmark. Driving it as a controlled value and pushing the router underneath
        would be a second source of truth about which screen is open.
    -->
    <nav
        v-if="activeTabs"
        class="-mx-3 mb-4 flex gap-1 overflow-x-auto border-b border-default px-3 sm:-mx-4 sm:px-4 lg:-mx-6 lg:px-6 print:hidden"
        :aria-label="$t(activeTabs.group.labelKey)"
        data-testid="nav-tabs"
    >
        <UButton
            v-for="item in activeTabs.items"
            :key="item.name"
            :to="{ name: item.name }"
            :data-testid="`nav-tab-${item.name}`"
            :label="item.label"
            :icon="item.icon"
            :color="activeName === item.name ? 'primary' : 'neutral'"
            variant="link"
            size="md"
            :aria-current="activeName === item.name ? 'page' : undefined"
            class="shrink-0 whitespace-nowrap rounded-none border-b-2 pb-2.5"
            :class="activeName === item.name ? 'border-primary' : 'border-transparent text-muted hover:text-default'"
        >
            <!-- The same badge the entry used to carry, beside the tab that owns it:
                 „Moje odobritve“ is no longer a line of the menu, and the number of
                 requisitions waiting for an approver is the reason it was there. It is
                 also added into the group's entry, so the count is visible without the
                 fold being open. Nothing is drawn for zero. -->
            <template v-if="item.badge" #trailing>
                <UBadge color="warning" variant="subtle" size="sm">{{ item.badge }}</UBadge>
            </template>
        </UButton>
    </nav>
</template>

<script lang="ts" setup>
    import { useNav } from '@/libs/nav'

    // The shared menu — the same filtered manifest the sidebar and the palette read.
    // See the note at the top of `libs/nav.ts`.
    const { activeName, activeTabs } = useNav()
</script>
